import { render, staticRenderFns } from "./traceabilityCodingList.vue?vue&type=template&id=22b984dd&scoped=true&"
import script from "./traceabilityCodingList.vue?vue&type=script&lang=js&"
export * from "./traceabilityCodingList.vue?vue&type=script&lang=js&"
import style0 from "./traceabilityCodingList.vue?vue&type=style&index=0&id=22b984dd&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22b984dd",
  null
  
)

export default component.exports